import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BackendUser {
  id?: number | string;
  name?: string;
  email?: string;
  user_type?: string;
  [key: string]: any;
}

interface UserState {
  user: any | null;       // Firebase User
  backendUser: BackendUser | null;  // backend profile (name, id, role)
  loading: boolean;
}

const initialState: UserState = {
  user: null,
  backendUser: null,
  loading: true,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<any | null>) => {
      state.user = action.payload;
      state.loading = false;
    },
    setBackendUser: (state, action: PayloadAction<BackendUser | null>) => {
      state.backendUser = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.backendUser = null;
      state.loading = false;
    },
  },
});

export const { setUser, setBackendUser, clearUser } = authSlice.actions;
export default authSlice.reducer;
